import dayjs from 'dayjs';
import { getStoredAccessToken, getStoredRefreshToken } from './localStorage';

/**
 * 从本地存储中获取存储的 JWT token，并解析出载荷部分
 * @returns {object|null} 解析后的载荷（Payload）对象，如果无法解析返回 null
 */
export function parseAccessToken(
  currToken?: string,
): Record<string, any> | null {
  try {
    const token = currToken || getStoredAccessToken(); // 获取 toke
    if (!token) {
      return null; // 如果没有 token，返回 null
    }

    const accessJWT = token.split('.')[1]; // 获取 JWT 的中间部分（Payload 部分）
    if (!accessJWT) {
      return null; // 如果没有找到有效的 Payload 部分，返回 null
    }

    const base64 = accessJWT.replace(/-/g, '+').replace(/_/g, '/'); // 转换为标准 Base64 编码
    const decodedPayload = JSON.parse(atob(base64)); // 解码并解析为 JSON 对象

    return decodedPayload; // 返回解析后的载荷对象
  } catch (error) {
    console.error('Error parsing JWT:', error); // 如果解析失败，输出错误信息
    return null; // 如果解析失败，返回 null
  }
}

/**
 * 判断 JWT 是否已过期
 * @returns {boolean} 如果 JWT 已过期，返回 true，否则返回 false
 */
export function isTokenExpired(): boolean {
  const payload = parseAccessToken();

  if (!payload || !payload.exp) {
    return true; // 如果解析失败或没有 exp 字段，认为 token 已过期
  }

  const currentTime = dayjs().utc().unix(); // 获取当前的 Unix 时间戳（秒）
  return payload.exp < currentTime; // 如果过期时间小于当前时间，则表示已过期
}

export function shouldRefresh(timer?: any): boolean {
  const payload = parseAccessToken();

  if (!payload || !payload.exp || !getStoredRefreshToken()) {
    if (timer) {
      clearInterval(timer);
    }
    return false; // 如果解析失败或没有 exp 字段，或者没有refreshToken，不触发refresh
  }

  const currentTime = dayjs().utc().unix(); // 获取当前的 Unix 时间戳（秒）
  return payload.exp - currentTime < 600; // 如果过期时间小于当前时间，则表示已过期
}
